import { render, staticRenderFns } from "./InventoryFiscal.vue?vue&type=template&id=29fabdb9&scoped=true"
import script from "./InventoryFiscal.vue?vue&type=script&lang=js"
export * from "./InventoryFiscal.vue?vue&type=script&lang=js"
import style0 from "./InventoryFiscal.vue?vue&type=style&index=0&id=29fabdb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fabdb9",
  null
  
)

export default component.exports